import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-72132732"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "user-manage-container"
};
const _hoisted_2 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_3 = {
  class: "flex align-center"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin-right": "10px"
  }
}, "应用配置名称", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "20px"
  }
}, null, -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin-right": "10px"
  }
}, "应用唯一编码", -1));
const _hoisted_7 = {
  style: {
    "width": "250px"
  }
};
const _hoisted_8 = {
  style: {
    "margin-left": "20px"
  }
};
const _hoisted_9 = {
  style: {
    "margin-top": "10px",
    "display": "flex",
    "justify-content": "space-between"
  }
};
import { findHisApplyConfigPage, deleteHisApplyById } from '@/api/upgrade';
import { onMounted, ref } from 'vue';
import Table from './components/table.vue';
import { appTableDataSchemas } from './config';
import { Search, Refresh } from '@element-plus/icons-vue';
import AddDialog from './components/add';
import usePagination from '@/hooks/usePagination';
import { ElMessageBox, ElMessage } from 'element-plus';
export default {
  __name: 'index',
  setup(__props) {
    const code = ref('');
    const name = ref('');
    const {
      currentPage,
      total,
      pageSize,
      setPageSize,
      setCurrentPage,
      setTotal
    } = usePagination();

    // 数据相关
    const tableData = ref([]);
    const loading = ref(false);
    // 获取数据的方法
    const getListData = async () => {
      loading.value = true;
      const result = await findHisApplyConfigPage({
        currentPage: currentPage.value,
        pageSize: pageSize.value,
        code: code.value,
        name: name.value
      });
      setTotal(result.total);
      tableData.value = result.records;
      loading.value = false;
    };
    onMounted(() => {
      getListData();
    });
    const handleRefresh = async () => {
      name.value = '';
      code.value = '';
      setCurrentPage(1);
      await getListData();
    };
    const handleCurrentChange = val => {
      setCurrentPage(val);
      getListData();
    };
    const handleChangeSize = e => {
      setPageSize(e);
      getListData();
    };
    const dialogVisible = ref(false);
    const addUserHandler = () => {
      dialogVisible.value = true;
    };
    const current = ref(null);
    const handleUpdate = row => {
      current.value = row;
      dialogVisible.value = true;
    };
    const handleDel = row => {
      ElMessageBox.confirm('确认要删除吗', {
        type: 'warning'
      }).then(async () => {
        try {
          await deleteHisApplyById(row);
          ElMessage.success('删除成功');
          // 重新渲染数据
          getListData();
        } catch (error) {
          ElMessage({
            message: error,
            type: 'error'
          });
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_card, {
        class: "header",
        shadow: "never"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createVNode(_component_el_input, {
          type: "text",
          style: {
            "width": "250px"
          },
          modelValue: name.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => name.value = $event),
          placeholder: "请输入应用配置名称"
        }, null, 8, ["modelValue"]), _hoisted_5, _hoisted_6, _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_input, {
          type: "text",
          modelValue: code.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => code.value = $event),
          placeholder: "请输入应用唯一编码"
        }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_button, {
          type: "primary",
          icon: _unref(Search),
          onClick: getListData
        }, {
          default: _withCtx(() => [_createTextVNode(" 查询 ")]),
          _: 1
        }, 8, ["icon"]), _createVNode(_component_el_button, {
          icon: _unref(Refresh),
          onClick: handleRefresh
        }, {
          default: _withCtx(() => [_createTextVNode(" 重置 ")]),
          _: 1
        }, 8, ["icon"])])]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          onClick: addUserHandler
        }, {
          default: _withCtx(() => [_createTextVNode(" 新增 ")]),
          _: 1
        })), [[_directive_permission, ['userAdd']]])]),
        _: 1
      }), _createVNode(_component_el_card, {
        shadow: "never"
      }, {
        default: _withCtx(() => [_createVNode(Table, {
          data: tableData.value,
          currentPage: _unref(currentPage),
          pageSize: _unref(pageSize),
          onUpdate: handleUpdate,
          onDel: handleDel,
          loading: loading.value,
          tableSchemas: _unref(appTableDataSchemas)
        }, null, 8, ["data", "currentPage", "pageSize", "loading", "tableSchemas"]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_pagination, {
          onCurrentChange: handleCurrentChange,
          onSizeChange: handleChangeSize,
          "page-sizes": [12, 24, 36],
          "current-page": _unref(currentPage),
          "page-size": _unref(pageSize),
          total: _unref(total),
          layout: "total, sizes, prev, pager, next, jumper",
          style: {
            "margin-bottom": "10px"
          }
        }, null, 8, ["current-page", "page-size", "total"])])]),
        _: 1
      }), _createVNode(_unref(AddDialog), {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => dialogVisible.value = $event),
        onRefreshData: getListData,
        model: current.value,
        onClearModel: _cache[3] || (_cache[3] = () => {
          current.value = null;
        })
      }, null, 8, ["modelValue", "model"])]);
    };
  }
};